module.exports = __webpack_public_path__ + "static/media/imagarena_text_logo.5055b4fd.png";